import {
  isEyewearHit,
  isStrapHit,
  isWatchHit,
} from '@/integrations/algolia/helpers';
import type {
  EyewearHit,
  StrapHit,
  WatchHit,
} from '@/integrations/algolia/types';
import type { ProductCatalogModeCtaStyle } from '@/lib/types';

import { EyewearCard, StrapCard, WatchCard } from './components';

export type ProductListingCardProps = {
  cardClickHandler?: () => void;
  hideFavorite?: boolean;
  hit: WatchHit | StrapHit | EyewearHit;
  isMostRelevantCta?: boolean;
  productCatalogMode?: boolean;
  productCatalogModeCtaStyle?: ProductCatalogModeCtaStyle;
  strapSizeDatas?: Record<string, any>;
};

export const ProductListingCard = ({
  cardClickHandler,
  hideFavorite = false,
  hit,
  isMostRelevantCta = false,
  productCatalogMode,
  productCatalogModeCtaStyle,
  strapSizeDatas,
}: ProductListingCardProps) => {
  if (isWatchHit(hit)) {
    return (
      <WatchCard
        cardClickHandler={cardClickHandler}
        data-test-id='ProductListingCardWatchCard'
        hideFavorite={hideFavorite}
        hit={hit as WatchHit}
        productCatalogMode={productCatalogMode}
        productCatalogModeCtaStyle={productCatalogModeCtaStyle}
        sizes='(max-width: 600px) 25vw, (max-width: 992px) 250px, (max-width: 1280px) 300px, 350px'
      />
    );
  }

  //TODO check is support strap material
  if (isStrapHit(hit)) {
    return (
      <StrapCard
        cardClickHandler={cardClickHandler}
        data-test-id='ProductListingCardStrapCard'
        hit={hit as StrapHit}
        isMostRelevantCta={isMostRelevantCta}
        productCatalogModeCtaStyle={productCatalogModeCtaStyle}
        sizes='25vw'
        strapSizeDatas={strapSizeDatas}
        type='square'
      />
    );
  }

  if (isEyewearHit(hit)) {
    return (
      <EyewearCard
        cardClickHandler={cardClickHandler}
        data-test-id='ProductListingCardStrapCard'
        hit={hit}
        productCatalogModeCtaStyle={productCatalogModeCtaStyle}
        sizes='25vw'
        type='square'
      />
    );
  }

  return null;
};
